let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bt5jQ")).then(() => parcelRequire('jwY65'));